import { render, staticRenderFns } from "./AuthenticationDialog.vue?vue&type=template&id=530e7c3a&scoped=true&"
import script from "./AuthenticationDialog.vue?vue&type=script&lang=js&"
export * from "./AuthenticationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationDialog.vue?vue&type=style&index=0&id=530e7c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e7c3a",
  null
  
)

export default component.exports